"use strict";

exports.__esModule = true;
exports.getMs = void 0;

var getMs = function getMs(seconds) {
  return seconds * 1000;
};

exports.getMs = getMs;